import { activeOrgSelector } from 'redux/reducer/AuthenticationReducer';
import { axiosInstance } from 'utils/http';
import { flow } from 'utils/urlConstants';
import { showAlert } from 'redux/actions/AlertActions';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect, useState } from 'react';
import { useMutation } from 'react-query';


export const useFetchCleanRoomFlowRunActionStatuses = ({ crId, crFlowId }) => {
  const { ID: orgId } = useSelector(activeOrgSelector);
  const dispatch = useDispatch();
  const [actions, setActions] = useState([]);

  const {
    isLoading, isError, isSuccess, data, mutate, reset,
  } = useMutation(
    ['Cr-Flow-Runs-Actions', crFlowId, orgId],
    async (payload) => axiosInstance.post(flow(orgId).actionsRunList(crId, crFlowId), payload),
    {
      onError: (err) => dispatch(showAlert({ message: err.response.data.message, type: 'error' })),
      select: (res) => res?.data?.actionsByRuns || [],
      retry: false,
      refetchOnWindowFocus: false,
    },
  );

  useEffect(() => {
    if (isSuccess) {
      setActions(data?.data?.actionsByRuns ?? []);
    }
  }, [isSuccess, data, setActions, reset]);

  return {
    isLoading, isError, isSuccess, data: actions, mutate,
  };
};
